// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2KPZb","content":"GlobalSearch_content__3jN_E"};